/**
 * 文件说明:
 * ----------------------------------------
 * 创建用户: leo
 * 创建日期 2019/7/10
 */

import request from 'crm/utils/request'
import api from 'crm/common/api/departments'
import {stringify} from 'qs'

export async function currentTree() {
    return request(api.currentTree.url, null, {
        checkMetaCode: false,
    })
}

export async function departments(params) {
    return request(`${api.departments.url}?${stringify(params)}`)
}
